import { getAccountList } from "@/utils/api";
import { getPageListOrder } from "@/utils/cloudstoreApi";
export const salesOrde = {
    data() {
        return {
            formData: {
                endTime: null,
                storesName: undefined,
                code: null,
                keywords: "",
                orderState: -1,
                outStoreName: undefined,
                startTime: null
            },
            dateValue: null,
            agentList: [],
            storesList: [],
            numObj: {
                notConfirm: 0,
                totalNumber: 0,
                yesConfirm: 0,
            },
            dataSource: [],
            ipagination: {
                current: 1,
                pageSize: 10,
                showTotal: (total, range) => {
                    return range[0] + "-" + range[1] + " 共" + total + "条"
                },
                showQuickJumper: true,
                showSizeChanger: true,
                total: 100
            },
            contentHeight: '',
            tableHeight: ''
        }
    },
    methods: {
        init() {
            // 表格高度计算
            let _that = this
            setTimeout(function() {
                let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
                let header = document.getElementById("header").offsetHeight;
                let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
                let pageHeight = document.getElementById('content').offsetHeight
                let makeTop = document.getElementById('page-top').offsetHeight
                let tabsTitleHeight = document.getElementsByClassName('ant-tabs-top-bar')[1].offsetHeight
                _that.contentHeight = pageHeight - makeTop - header - breadcrumb - tdHeight * 2.05
                _that.tableHeight = _that.contentHeight - tdHeight - tabsTitleHeight
            }, 50)
            this.getShopList()
            this.getMenuList()
        },
        // 选择筛选日期
        changeData(date, dateString) {
            this.dateValue = date;
            this.formData.startTime = dateString[0];
            this.formData.endTime = dateString[1];
        },
        // 门店列表
        getShopList() {
            getAccountList({}).then(res => {
                if (res.success) {
                    this.storesList = res.result
                }
            })
        },
        // 选择门店
        selectStores(e) {
            console.log(e)
        },
        // 页面变化时回调
        onChangeIpagination(current) {
            this.ipagination.current = current
            this.getMenuList()
        },
        // 一页显示条数变化时回调
        onShowSizeChange(current, pageSize) {
            this.ipagination.current = current
            this.ipagination.pageSize = pageSize
            this.getMenuList()
        },
        // 重置数据
        btnResetData() {
            this.dateValue = null
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.confirmFlag = null
            this.formData = {
                contactCustomerName: ''
            }
            this.getMenuList()
        },
        // 筛选
        btnInquire() {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.getMenuList()
        },
        // 切换类型
        callback(e) {
            this.ipagination.current = 1
            this.ipagination.pageSize = 10
            this.formData.orderState = e
            this.getMenuList()
        },
        // 获取表格数据
        getMenuList() {
            this.$store.state.isLoding = true
            this.formData.pageNo = this.ipagination.current
            this.formData.pageSize = this.ipagination.pageSize
            let params = this.formData
            let header = {
                companyStoreId: this.$store.state.userInfo.companyStoreId
            }
            console.log(this.formData)
            getPageListOrder(params, header).then((res) => {
                if (res.code == 200) {
                    this.dataSource = res.result.records
                    this.ipagination.total = Number(res.result.total)
                    this.$store.state.isLoding = false
                }
            });
        },
    }
}